/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthService } from './services/auth.service';
import { NotificationsService } from './services/notifications.service';
import { MacroBudgetItemsService } from './services/macro-budget-items.service';
import { QuoteService } from './services/quote.service';
import { UserService } from './services/user.service';
import { CashFundsService } from './services/cash-funds.service';
import { FilesService } from './services/files.service';
import { SupplyEntryService } from './services/supply-entry.service';
import { CardService } from './services/card.service';
import { RecurringPaymentAuthorizationsService } from './services/recurring-payment-authorizations.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthService,
    NotificationsService,
    MacroBudgetItemsService,
    QuoteService,
    UserService,
    CashFundsService,
    FilesService,
    SupplyEntryService,
    CardService,
    RecurringPaymentAuthorizationsService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
